import { render, staticRenderFns } from "./UpdateAuthorityGroupUsersPopup.vue?vue&type=template&id=5090b96e&scoped=true&"
import script from "./UpdateAuthorityGroupUsersPopup.vue?vue&type=script&lang=js&"
export * from "./UpdateAuthorityGroupUsersPopup.vue?vue&type=script&lang=js&"
import style0 from "./UpdateAuthorityGroupUsersPopup.vue?vue&type=style&index=0&id=5090b96e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5090b96e",
  null
  
)

export default component.exports